import React, { useState } from "react";
import { Alert, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { GameToBrowserButton } from "@components/Game/Misc";
import { Awesome, DevModal, YesNoColumn } from "@components/Helpers";
import { url_reverse } from "@components/Utils";

export function MarketOrderInfoModal({ orderInfo, setOrderInfo }) {
    const { t } = useTranslation();

    return (
        <DevModal
            size="lg"
            show={orderInfo}
            onHide={() => setOrderInfo(null)}
            header={`#${orderInfo?.id}`}
            body={
                orderInfo && (
                    <Table size="sm" bordered striped responsive style={{ fontSize: "10pt" }}>
                        <tbody>
                            <tr>
                                <th style={{ minWidth: "220px" }}>Buyer email</th>
                                <td>{orderInfo.buyer_email}</td>
                            </tr>
                            <tr>
                                <th>Buyer user_id</th>
                                <td>{orderInfo.buyer_user_id}</td>
                            </tr>
                            <tr>
                                <th>Owner email</th>
                                <td>{orderInfo.email}</td>
                            </tr>
                            <tr>
                                <th>Owner user_id</th>
                                <td>{orderInfo.user_id}</td>
                            </tr>
                            <tr>
                                <th>{t("Игра")}</th>
                                <td>{orderInfo.game.base_locale_object.name}</td>
                            </tr>
                            <tr>
                                <th>{t("Состояние")}</th>
                                <td>{orderInfo.state}</td>
                            </tr>
                            <tr>
                                <th>{t("Цена")}</th>
                                <td>{orderInfo.price}</td>
                            </tr>
                            <tr>
                                <th>{t("Первоначальная цена")}</th>
                                <td>{orderInfo.original_price}</td>
                            </tr>
                            <tr>
                                <th>{t("Дата заказа")}</th>
                                <td>{orderInfo.date_ordered}</td>
                            </tr>
                            <tr>
                                <th>{t("Дата оплаты")}</th>
                                <td>{orderInfo.date_payed}</td>
                            </tr>
                            <tr>
                                <th>{t("Дата выдачи серийника")}</th>
                                <td>{orderInfo.date_serial}</td>
                            </tr>
                            <tr>
                                <th>{t("Валюта")}</th>
                                <td>{orderInfo.currency}</td>
                            </tr>
                            <tr>
                                <th>RB Country</th>
                                <td>{orderInfo.rb_country}</td>
                            </tr>
                            <tr>
                                <th>{t("Транзакция")}</th>
                                <td>{orderInfo.payment_id}</td>
                            </tr>
                            <tr>
                                <th>{t("Сумма платежа")}</th>
                                <td>{orderInfo.payment_sum}</td>
                            </tr>
                            <tr>
                                <th>{t("Тип платежа")}</th>
                                <td>{orderInfo.payment_type}</td>
                            </tr>
                            <tr>
                                <th>{t("Ошибка платежа")}</th>
                                <td>{orderInfo.payment_error}</td>
                            </tr>
                            <tr>
                                <th>{t("Серийник")}</th>
                                <td>{orderInfo.serial}</td>
                            </tr>
                            <tr>
                                <th>serialinfo</th>
                                <td>{JSON.stringify(orderInfo.serialinfo, null, 2)}</td>
                            </tr>
                            <tr>
                                <th>{t("Ошибка выдачи серийника")}</th>
                                <td>{orderInfo.serial_error}</td>
                            </tr>
                            <tr>
                                <th>{t("ID чека")}</th>
                                <td>
                                    {orderInfo.receipt_id && (
                                        <a
                                            href={`https://money.mail.ru/fiscal/get/${orderInfo.receipt_id}`}
                                            target="_blank"
                                        >
                                            {orderInfo.receipt_id}
                                        </a>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th>admin_email</th>
                                <td>{orderInfo.admin_email}</td>
                            </tr>
                            <tr>
                                <th>{t("Родительский заказ")}</th>
                                <td>{orderInfo.parent_id}</td>
                            </tr>
                            <tr>
                                <th>gift_code</th>
                                <td>{orderInfo.gift_code}</td>
                            </tr>
                            <tr>
                                <th>merchant_id</th>
                                <td>{orderInfo.merchant_id}</td>
                            </tr>
                            <tr>
                                <th>revenue_share</th>
                                <td>{orderInfo.revenue_share}</td>
                            </tr>
                            <tr>
                                <th>tax_type</th>
                                <td>{orderInfo.tax_type}</td>
                            </tr>
                            <tr>
                                <th>extrainfo</th>
                                <td>{JSON.stringify(orderInfo.extrainfo, null, 2)}</td>
                            </tr>
                            <tr>
                                <th>discountinfo</th>
                                <td>{JSON.stringify(orderInfo.discountinfo, null, 2)}</td>
                            </tr>
                            {orderInfo.is_refund && (
                                <>
                                    <tr>
                                        <th>{t("ID чека возврата")}</th>
                                        <td>{orderInfo.refund_receipt_id}</td>
                                    </tr>
                                    <tr>
                                        <th>{t("Дата возврата")}</th>
                                        <td>{orderInfo.date_refunded}</td>
                                    </tr>
                                    <tr>
                                        <th>refundinfo</th>
                                        <td>{JSON.stringify(orderInfo.refundinfo, null, 2)}</td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                )
            }
        />
    );
}

export function MarketOrderTable({ selectable = false, refundColumn = false }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppContext();
    const [orderInfo, setOrderInfo] = useState(null);
    const [returnMoney, setReturnMoney] = useState(null);
    const { api_post_formdata } = useRequest();

    const handleReturnMoney = (ev) => {
        const order = apiData.object_list[returnMoney.ind];
        const formData = new FormData();
        formData.append(ev.target.name, ev.target.value);
        formData.append("order_id", order.id);
        formData.append("comment", returnMoney.comment || "");
        api_post_formdata(ev, apiUrl, formData, {
            then: (resp) => {
                if (resp.status === "ok") {
                    const newApiData = { ...apiData };
                    newApiData.object_list[returnMoney.ind].is_refund = true;
                    setApiData(newApiData);
                }
                setReturnMoney(null);
            },
        });
    };

    return (
        <>
            <MarketOrderInfoModal orderInfo={orderInfo} setOrderInfo={setOrderInfo} />

            <DevModal
                show={returnMoney}
                onHide={() => setReturnMoney(null)}
                header={t("Сделать возврат")}
                body={
                    returnMoney && (
                        <>
                            {apiData.object_list[returnMoney.ind].game_is_non_refundable && (
                                <Alert variant="danger">
                                    {t(
                                        "Внимание! Товар содержит расходуемый контент. В связи с этим он не подлежит возврату."
                                    )}
                                </Alert>
                            )}
                            {returnMoney.isExpired && (
                                <Alert variant="danger">
                                    {t(
                                        "Внимание! С момента заказа прошло более 7 дней. В связи с этим он не подлежит возврату."
                                    )}
                                </Alert>
                            )}
                            {t("Заказ")}: {apiData.object_list[returnMoney.ind].id}
                            <DevForm.TextArea
                                name="comment"
                                value={returnMoney.comment || ""}
                                onChange={(e) => setReturnMoney((prev) => ({ ...prev, comment: e.target.value }))}
                                placeholder={t("Комментарий")}
                            />
                        </>
                    )
                }
                footer={
                    <DevForm.Button variant="primary" name="action" value="refund_order" onClick={handleReturnMoney}>
                        {t("Возврат")}
                    </DevForm.Button>
                }
            />

            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        {selectable && <th style={{ width: "25px" }} />}
                        <th>ID</th>
                        <th>Buyer email</th>
                        <th>Owner email</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Дата заказа")}</th>
                        <th>{t("Цена продажи")}</th>
                        <th>{t("Тип платежа")}</th>
                        <th>{t("Игра")}</th>
                        {refundColumn && <th>{t("Возврат")}</th>}
                        <th style={{ width: "6%" }} />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, ind) => {
                        return (
                            <React.Fragment key={`object_list${o.id}`}>
                                <ListItem
                                    apiData={apiData}
                                    setApiData={setApiData}
                                    obj={o}
                                    setOrderInfo={setOrderInfo}
                                    selectable={selectable}
                                    listIndex={ind}
                                    setReturnMoney={setReturnMoney}
                                    refundColumn={refundColumn}
                                />
                                {o.show_childs &&
                                    o.__childs.map((ch) => {
                                        return (
                                            <ListItem
                                                key={`child_${ch.id}`}
                                                apiData={apiData}
                                                setApiData={setApiData}
                                                obj={ch}
                                                setOrderInfo={setOrderInfo}
                                                selectable={selectable}
                                            />
                                        );
                                    })}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </Table>
        </>
    );
}

function ListItem({ apiData, setApiData, obj, setOrderInfo, selectable, listIndex, setReturnMoney, refundColumn }) {
    const { t } = useTranslation();

    const onTrigger = (ev, order) => {
        ev.preventDefault();

        const newApiData = { ...apiData };
        newApiData.object_list.map((o) => {
            if (o.id === order.id) {
                o.show_childs = Boolean(!o.show_childs);
            }
            return o;
        });
        setApiData(newApiData);
    };

    const isOrderExpired = (dateOrdered) => {
        if (!dateOrdered) return false;

        const orderDate = new Date(dateOrdered);
        const currentDate = new Date();
        const diffTime = currentDate - orderDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        return diffDays > 7;
    };

    const dmrRefundBtn = () => {
        const isExpired = isOrderExpired(obj.date_ordered);
        return (
            <DevForm.Button
                variant="warning"
                size="sm"
                name="refund_dmr"
                onClick={() => setReturnMoney((prev) => ({ ...prev, ind: listIndex, isExpired }))}
            >
                {t("Возврат DMR")}
            </DevForm.Button>
        );
    };

    const dolyameRefundBtn = () => {
        return (
            <DevForm.Button
                variant="warning"
                size="sm"
                name="refund_dolyame"
                onClick={() => setReturnMoney((prev) => ({ ...prev, ind: listIndex }))}
            >
                {t("Возврат DOLYAME")}
            </DevForm.Button>
        );
    };

    const chastyamiRefundBtn = () => {
        return (
            <DevForm.Button
                variant="warning"
                size="sm"
                name="refund_chastyami"
                onClick={() => setReturnMoney((prev) => ({ ...prev, ind: listIndex }))}
            >
                {t("Возврат CHASTYAMI")}
            </DevForm.Button>
        );
    };

    let tr_class = "";
    if (obj.parent_id) {
        tr_class = "table-info";
    }
    if (obj.is_refund) {
        tr_class = "table-warning";
    }

    return (
        <tr className={tr_class}>
            {selectable && (
                <td>
                    {!obj.parent_id && (
                        <DevForm.Checkbox
                            checked={obj.chosen}
                            onChange={(ev) => {
                                const newApiData = { ...apiData };
                                newApiData.object_list.map((o) => {
                                    if (o.id === obj.id) {
                                        o.chosen = ev.target.checked;
                                    }
                                    return o;
                                });
                                setApiData(newApiData);
                            }}
                        />
                    )}
                </td>
            )}
            <td>
                <a
                    href="#"
                    onClick={(ev) => {
                        ev.preventDefault();
                        setOrderInfo(obj);
                    }}
                >
                    {obj.id}
                </a>
            </td>
            <td>{obj.buyer_email}</td>
            <td>{obj.email}</td>
            <td>{obj.state}</td>
            <td>{obj.date_ordered}</td>
            <td>{obj.price}</td>
            <td>{obj.payment_type}</td>
            <td>
                <Link to={url_reverse("games:page", { game_id: obj.game.id })}>{obj.game.base_locale_object.name}</Link>
                <GameToBrowserButton game={obj.game} />
            </td>
            {refundColumn && (
                <td>
                    {obj.is_refund && <YesNoColumn attr={obj.is_refund} />}
                    {obj.__can_full_refund &&
                        !obj.is_refund &&
                        !obj.__is_dolyame &&
                        !obj.__is_chastyami &&
                        dmrRefundBtn()}
                    {obj.__can_full_refund && !obj.is_refund && obj.__is_dolyame && dolyameRefundBtn()}
                    {obj.__can_full_refund && !obj.is_refund && obj.__is_chastyami && chastyamiRefundBtn()}
                </td>
            )}
            <td className="dmg-table-row-tools">
                {obj.__childs?.length > 0 && (
                    <a href="#" onClick={(ev) => onTrigger(ev, obj)}>
                        <Awesome type="shopping-cart" />
                    </a>
                )}
            </td>
        </tr>
    );
}
